import React, { Component } from "react";
import { Form, Input } from "semantic-ui-react";
import "../assets/styles/registerForm.scss";
import axios from "axios";
import { registrationEndpoint } from "../constants";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-semantic-toasts";
import qs from 'qs';
// import {withUserContext} from "./ModalContext";

const validationSchema = Yup.object({
  name: Yup.string()
    .max(45, "Name is Too Long")
    .min(2, "Name is Too Short")
    .required("Required"),
  email: Yup.string().email("Invalid Email Address").required("Required"),
    institute: Yup.string().required("Required"),
});

class RegisterForm extends Component {
  constructor() {
    super();

    this.state = {
      loading: false,
      name: "",
      email: "",
      college: "",
    };
  }


  render() {
    return (
      <div>
        <Formik
          initialValues={{
            name: "",
            email: "",
              institute: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            this.setState({ loading: true });

            const { name, email, institute } = values;
            axios
              .post(
                registrationEndpoint,
                qs.stringify({
                  name,
                  email,
                    institute,
                }),{
                  headers:{
                    'Content-Type': 'application/x-www-form-urlencoded',
                  }
                  }
              )
              .then((res) => {
                toast({
                  title: "Success",
                  description: "You have Registered for Elan and ηvision 2021",
                  type: "success",
                });
                this.props.setShow(false)
                this.setState({ loading: false });
              })
              .catch((err) => {
                toast({
                  title: "Error",
                  description: "There was an error. Please Try again later",
                  type: "error",
                });
                this.props.setShow(false)
                this.setState({ loading: false });
              });
          }}
          validateOnChange={true}
          validateOnBlur={false}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (

            <Form className={"register-form"}>
              <Form.Group>
                <Form.Field
                  onChange={handleChange}
                  control={Input}
                  name={"name"}
                  value={values.name}
                  placeholder={"Name"}
                  fluid
                  error={touched.name && errors.name && errors.name !== ""}
                  width={16}
                />
              </Form.Group>

              <Form.Group>
                <Form.Field
                  onChange={handleChange}
                  control={Input}
                  name={"email"}
                  value={values.email}
                  placeholder={"Email"}
                  error={touched.email && errors.email && errors.email !== ""}
                  fluid
                  width={16}
                />
              </Form.Group>

              <Form.Group>
                <Form.Field
                  onChange={handleChange}
                  control={Input}
                  value={values.institute}
                  name={"institute"}
                  error={touched.institute && errors.institute && errors.institute !== ""}
                  placeholder={"College"}
                  fluid
                  width={16}
                />
              </Form.Group>

              <Form.Button
                disabled={this.state.loading}
                loading={this.state.loading}
                onClick={handleSubmit}
              >
                SUBMIT
              </Form.Button>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default RegisterForm;
